export enum DentalNotationType {
  Fdi = 'Fdi',
  Palmer = 'Palmer',
  Universal = 'Universal'
}